import { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import {
   CACHE_FIRST_FETCH_POLICY,
   NETWORK_ONLY_FETCH_POLICY
} from '@flowwai-frontend/bps-officer-web/graphql'

import {
   GetCurrentUserProfileDocument,
   GetCurrentUserProfileQueryResult,
   GetCurrentUserProfileQueryVariables
} from '../../query/GetCurrentUserDetails/query.generatedTypes'

import {
   GetUserAppConfigDocument,
   GetUserAppConfigQueryResult,
   GetUserAppConfigQueryVariables
} from '../../query/GetUserAppConfig/query.generatedTypes'

import { UserService } from '.'

class UserServiceAPI implements UserService {
   client: ApolloClient<NormalizedCacheObject>

   constructor(client: ApolloClient<NormalizedCacheObject>) {
      this.client = client
   }

   getUserProfile = (
      requestObject: GetCurrentUserProfileQueryVariables
   ): Promise<GetCurrentUserProfileQueryResult | unknown> =>
      this.client.query({
         query: GetCurrentUserProfileDocument,
         variables: requestObject
      })

   getUserAppConfig = (
      requestObject: GetUserAppConfigQueryVariables
   ): Promise<GetUserAppConfigQueryResult | unknown> =>
      this.client.query({
         query: GetUserAppConfigDocument,
         variables: requestObject,
         fetchPolicy: 'network-only'
      })
}

export { UserServiceAPI }
